export const paths = {
  // Sections
  ips: 'cdaReader',
  alerts: 'alerts',
  dailyMonitoring: 'dailyMonitoring',
  somatometrics: 'somatometrics',
  medicalProblems: 'medicalProblems',
  medicalHistorySection: 'medicalHistory',
  pregnancy: 'pregnancy',
  gynaecology: 'gynaecology',
  hysteroscopy: 'hysteroscopy',
  medicationSummary: 'medicationSummary',
  socialHistory: 'socialHistory',
  laboratory: 'laboratory',
  imaging: 'imaging',
  healthCarePlan: 'carePlan',
  careTeam: 'careTeam',
  travelHistory: 'travelHistory',
  episodeOfCare: 'episodeOfCare',
  pilotStudy: 'pilotStudy',
  tracheostomy: 'tracheostomy',
  etiology: 'etiology',
  complication: 'complication',
  comorbidity: 'comorbidity',
  preciousAi: 'preciousAi',
  patientCharacteristics: 'patientCharacteristics',
  initialAssessments: 'initialAssessments',
  departmentalQuestionnaires: 'departmentalQuestionnaires',
  pilotQuestionnaires: 'pilotQuestionnaires',
  neurologicalRehabilitation: 'neurologicalRehabilitation',
  selfReport: 'selfReport',

  // Sub-items
  vitalSigns: 'vitalSigns',
  arterialBloodGas: 'arterialBloodGas',
  glasgow: 'glasgow',
  glucose: 'glucose',
  nutritionIntake: 'nutritionIntake',
  neck: 'neckSize',
  weight: 'weight',
  allergies: 'allergies',
  medicalAlert: 'medicalAlert',
  vaccinations: 'vaccinations',
  resolvedProblems: 'resolvedProblems',
  medicalHistory: 'medical',
  currentProblems: 'currentProblems',
  devicesAndImplants: 'deviceAndImplants',
  procedures: 'procedures',
  currentMedicines: 'medicines',
  pastMedicines: 'pastMedicines',
  activeEpisodeOfCare: 'activeEpisodeOfCare',
  pastEpisodeOfCare: 'pastEpisodeOfCare',

  // socialHistoryObservations: 'socialHistoryObservations',
  // socialHistoryQuestionnaire: 'socialHistoryQuestionnaire',

  laboratoryFiles: 'laboratoryFiles',
  laboratoryResults: 'laboratoryResults',

  imagingFiles: 'imagingFiles',
  multipleSclerosisSegmentation: 'multipleSclerosisSegmentation',
  preciousMedSamSegmentation: 'preciousMedSamSegmentation',
  protectMedSamSegmentation: 'protectMedSamSegmentation',

  ctParameters: 'ctParameters',
  tubeCharacteristics: 'tubeCharacteristics',
  capnography: 'capnography',
  hysteroscopyFiles: 'hysteroscopyFiles',

  socialQuestionnaireAmen: 'socialQuestionnaireAmen',
  supportingDocumentsAmen: 'supportingDocumentsAmen',
  fastProtocolQuestionnaireMediterrenean:
    'fastProtocolQuestionnaireMediterrenean',

  // Departmental Questionnaire
  // Speech
  speechTherapyQuestionnaire: 'speechTherapyQuestionnaire',
  parkinsonsQuestionnaire: 'parkinsonsQuestionnaire',
  becksDepressionInventory: 'becksDepressionInventory',
  oralClinicalAssessmentOfDeposition: 'oralClinicalAssessmentOfDeposition',
  // Physiotherapy
  physiotherapyQuestionnaire: 'physiotherapyQuestionnaire',
  patientAssessmentCard: 'patientAssessmentCard',
  sldcQuestionnaire: 'sldcQuestionnaire',
  slagQuestionnaire: 'slagQuestionnaire',

  // Neurological Rehabilitation
  // Balance and Gait
  balanceAndGait: 'balanceAndGait',
  bergBalanceScale: 'bergBalanceScale',
  miniBestest: 'miniBestest',
  // The six minute walk test, named "meter" in the backend menu
  sixMeterWalkTest: 'sixMeterWalkTest',
  tenMeterWalkTest: 'tenMeterWalkTest',
  functionalAmbulationCategory: 'functionalAmbulationCategory',
  functionalGaitAssessment: 'functionalGaitAssessment',
  // The timed up and go test, named "Time Up and Go Test" in the backend menu
  timeUpAndGoTest: 'timeUpAndGoTest',
  modifiedAshworthScale: 'modifiedAshworthScale',
  // Neurodegenerative Disorders
  neurodegenerativeDisorders: 'neurodegenerativeDisorders',
  modifiedFatigueImpactScale: 'modifiedFatigueImpactScale',
  // Stroke and Brain Injury
  strokeAndBrainInjury: 'strokeAndBrainInjury',
  fuglMeyerAssessment: 'fuglMeyerAssessment',
  trunkControlTest: 'trunkControlTest',
  trunkImpairmentScale: 'trunkImpairmentScale',
  strokeScoreQuestionnaireMediterrenean:
    'strokeScoreQuestionnaireMediterrenean',
  // Depression and Anxiety
  depressionAndAnxiety: 'depressionAndAnxiety',
  geriatricDepressionScale: 'geriatricDepressionScale',
  // General
  general: 'general',
  medicalResearchCouncilScale: 'medicalResearchCouncilScale',
  barthelIndex: 'barthelIndex',
  functionalIndependenceMeasure: 'functionalIndependenceMeasure',
  motricityIndex: 'motricityIndex',

  // Pilot Questionnaires
  // Veles
  velesQuestionnaires: 'velesQuestionnaires',
  dn4: 'dn4',
  pdquestionnaire: 'pdquestionnaire',
  eq5d: 'eq5d',
  pacslac2: 'pacslac2',
  painad: 'painad',
  mobid: 'mobid',
  mocaAssessment: 'mocaAssessment',

  // Workspace
  workspace: {
    myPatients: 'myPatients',
    incomingReferrals: 'incomingReferrals',
    outgoingReferrals: 'outgoingReferrals',
  },

  // Tenant Management
  tenantManagement: {
    userManagement: 'userManagement',
    careTeamTemplates: 'careTeamTemplates',
  },
};
